var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhoneIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 1.263,
  d: "M20 19.333C8.8 19.333 4.667 9.111 4 4h5.333l1.334 4L8 9.333c1.067 3.2 4.444 5.778 6 6.667l2-2 4 .667z"
})));
export { SvgPhoneIcon as ReactComponent };
export default "/_next/static/images/phone-icon.svg";